// Frontend/components/loans/LoanApplicationDocument.tsx
import React from 'react';
import {CompanyDTO, CustomerProfileDTO, LoanFormConfigDTO} from "@/shared/api/model";
import ConfigurableLoanApplicationDocument from './ConfigurableLoanApplicationDocument';

interface LoanApplicationDocumentProps {
    user: any;
    product: any;
    amount: string | undefined;
    period: string | undefined;
    scheduleData: any;
    company: CompanyDTO|undefined;
    customerProfile?: CustomerProfileDTO;
    disbursementInstitutionName?: string;
    formConfig?: LoanFormConfigDTO;
}

const LoanApplicationDocument: React.FC<LoanApplicationDocumentProps> = ({
                                                                               user,
                                                                               product,
                                                                               amount,
                                                                               period,
                                                                               scheduleData,
                                                                               company,
                                                                               customerProfile,
                                                                               disbursementInstitutionName,
                                                                               formConfig
                                                                           }) => {
    return (
        <ConfigurableLoanApplicationDocument
            user={user}
            product={product}
            amount={amount}
            period={period}
            scheduleData={scheduleData}
            company={company}
            customerProfile={customerProfile}
            disbursementInstitutionName={disbursementInstitutionName}
            formConfig={formConfig}
        />
    );
};

export default LoanApplicationDocument;